// extracted by mini-css-extract-plugin
export default {"faqContainer":"index__faqContainer--Von51","title":"index__title--Ksk21"};